import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { Grid, Row, Col } from 'react-bootstrap'
import styles from './Home.css'
import { homeData } from '../../modules/store'
import { observer } from 'mobx-react'
import { homeDataRequest, getBlogRequest } from '../../modules/communication'
import Welcome from '../../components/welcome/Welcome'
import References from '../../components/references/References'
import Employes from '../../components/employes/Employes'
import Blog from '../../components/blog/Blog'
import Contact from '../../components/contact/Contact'
import ScrollOffset from '../../components/scrollOffset/ScrollOffset'

export default observer(class Home extends Component {
    constructor(props) {
        super(props);
        window.addEventListener('unload', function(e){
            window.scrollTo(0, 0);
        });
    }

    componentWillMount() {
        homeDataRequest()
        getBlogRequest()
    }

    componentDidUpdate() {
      this.scrollIntoView();
    }

    scrollIntoView = () => {
        const node = ReactDOM.findDOMNode(this[this.props.match.params.section])
        if (node) {
          node.scrollIntoView({ block: "start", behavior: "smooth" })
        }
    };


    render() {
        return (
            <div>
                <div className={styles.top}>
                    <Grid>
                        <Row>
                            <Col lg={12}>
                                <section id='welcome'>
                                    <ScrollOffset refFunction={ref => this.welcome = ref} offset={130} />
                                    <Welcome welcome={homeData.data.welcome} />
                                </section>
                            </Col>
                        </Row>
                    </Grid>
                </div>
                <Grid>
                    <Row id="main-content">
                        <Col id="references-employes-container" md={8} ref={ref => this.referencesEmployesColumn = ref}>
                            <section id='references'>
                                <ScrollOffset refFunction={ref => this.references = ref} offset={80} />
                                <References references={homeData.data.references} />
                            </section>
                            <section id='employes'>
                                <ScrollOffset refFunction={ref => this.employes = ref} offset={80} />
                                <Employes employes={homeData.data.employes} />
                            </section>
                        </Col>
                        <Col id="blog-container" md={4} ref={ref => this.blogColumn = ref}>
                            <section id='blog'>
                                <ScrollOffset refFunction={ref => this.blog = ref} offset={80} />
                                <Blog />
                            </section>
                        </Col>
                    </Row>
                </Grid>
                <footer id="footer">
                    <Grid>
                        <Row>
                            <Col lg={12}>
                                <ScrollOffset refFunction={ref => this.footer = ref} offset={80} />
                                <Contact contact={homeData.data.contact} />
                            </Col>
                        </Row>
                    </Grid>
                </footer>
            </div>
        )
    }
})


// WEBPACK FOOTER //
// ./src/containers/home/Home.js